<!-- Header -->
<app-details-page-header
  [title]="legalEntity()?.name ?? '-'"
  [id]="entityId()"
  (back)="goBack()"
>
  <app-button
    [loading]="isToggling()"
    [disabled]="!canToggle()"
    [iconClass]="isDeactivated ? 'fas fa-play' : 'fas fa-pause'"
    [label]="
      isDeactivated
        ? ('admin.users.actions.reactivate' | translate)
        : ('admin.users.actions.suspend' | translate)
    "
    (clicked)="onToggleActivation()"
  />

  <app-button
    [loading]="isDeleting()"
    [disabled]="!canDelete()"
    [iconClass]="'fas fa-trash-alt'"
    [label]="'general.remove' | translate"
    btnClass="btn btn-falcon-default btn-sm d-flex align-items-center gap-2"
    (clicked)="onDelete()"
  />
</app-details-page-header>

<!-- Main content -->
<div class="card card-details shadow-sm border-0 py-2 mt-3">
  <ul class="nav nav-tabs mb-2" role="tablist">
    <li class="nav-item" role="presentation" *ngFor="let tab of tabs">
      <a
        class="nav-link"
        [class.active]="activeTab() === tab.key"
        role="tab"
        [attr.aria-controls]="tab.key"
        [attr.aria-selected]="activeTab() === tab.key"
        (click)="setTab(tab.key)"
      >
        {{ tab.label | translate }}
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab() === 'details'"
      [class.active]="activeTab() === 'details'"
      id="details"
      role="tabpanel"
    >
      <app-details-tab [entity]="legalEntity()"></app-details-tab>
    </div>

    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab() === 'representatives'"
      [class.active]="activeTab() === 'representatives'"
      id="entities"
      role="tabpanel"
    >
      <app-representatives-tab
        [legalEntityId]="entityId()"
      ></app-representatives-tab>
    </div>

    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab() === 'qualification'"
      [class.active]="activeTab() === 'qualification'"
      id="qualification"
      role="tabpanel"
    >
      <app-qualification-tab [entity]="legalEntity()"></app-qualification-tab>
    </div>
  </div>
</div>

<!-- Footer buttons only for the DETAILS tab -->
@if (activeTab() === 'details') {
<div class="d-flex justify-content-end gap-2 px-4 pb-4">
  <app-button
    [loading]="isCancelling()"
    [disabled]="isSaving() || isCancelling()"
    [label]="'general.cancel' | translate"
    variant="default"
    (clicked)="onCancelDetails()"
  />

  <app-button
    [loading]="isSaving()"
    [disabled]="isSaving() || isCancelling()"
    [iconClass]="'fas fa-save'"
    [label]="'general.save' | translate"
    btnClass="btn btn-primary btn-sm action-btn"
    (clicked)="onSaveDetails()"
  ></app-button>
</div>

}
